// extracted by mini-css-extract-plugin
export default {"root":"sidebar_root__o4hTr","a":"sidebar_a__lAgSE","footer":"sidebar_footer__blQlk","menu":"sidebar_menu__3P9Ea","section":"sidebar_section__CjzwB"};